import React, { FC, useCallback, useEffect, useState } from 'react'
import './LandingFilterOverlay.scss'
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { IFilterItem } from 'app_types/campus/academic/courseTypes'
import CourseService from 'app_services/campus/academic/courseService'
import { IFilterOnChangeParams } from 'app_components/screens/landing/AcademicFilterScreen/components/FilterCourseCharacteristics/FilterCourseCharacteristics'

interface ILandingFilterOverlayProps {
  onChange: (params: IFilterOnChangeParams) => void
  onClear: () => void
  onFilter: () => void
}

const LandingFilterOverlay: FC<ILandingFilterOverlayProps> = ({
  onChange,
  onClear,
  onFilter
}) => {
  const [dateFrom, setDateFrom] = useState<string>()
  const [dateTo, setDateTo] = useState<string>()
  const [filters, setFilters] = useState<IFilterItem[]>([])
  const [selectedItems, setSelectedItems] = useState<string[]>([])

  const getFilter = async () => {
    const courseService = new CourseService()
    const response = await courseService.getActivePublicFilter()

    if(response){
      setFilters(response.filters)
    }
  }

  useEffect(() => {
    getFilter()
  }, [])

  const handleClickClear = () => {
    setDateFrom('')
    setDateTo('')
    setSelectedItems([])
    onClear && onClear()
  }

  const handleClickItem = (id: string) => {
    const itemIndex = selectedItems.findIndex((item) => item===id)
    if (itemIndex >= 0){
      const newItems= [...selectedItems]
      newItems.splice(itemIndex, 1)
      setSelectedItems(newItems)
    } else {
      const newItems = [...selectedItems]
      newItems.push(id)
      setSelectedItems(newItems)
    }
  }

  const handleSendOnChange = useCallback(() => {
    onChange && onChange({
      endDate: dateTo,
      startDate: dateFrom,
      filterCategories: selectedItems,
    })
  }, [dateFrom, dateTo, onChange, selectedItems])

  useEffect(() => {
    handleSendOnChange()
  }, [handleSendOnChange])

  const handleClickFilter = () => {
    onFilter && onFilter()
  }

  return (
    <div className='landing-filter-overlay--layout'>
      <h5>Filtros</h5>
      <p className='landing-filter-overlay--section-title'>Por fecha</p>
      <div className='landing-filter-overlay--dates-container'>
        <div>
          <input value={dateFrom} onChange={(event) => {setDateFrom(event.target.value)}} type='date' className='filter-course-characteristics--input-date'></input>
        </div>
        <p>A</p>
        <div>
          <input value={dateTo} onChange={(event) => {setDateTo(event.target.value)}} type='date' className='filter-course-characteristics--input-date'></input>
        </div>
      </div>
      <div className='landing-filter-overlay--list-container'>
        {filters?.map((filter) => (
          <div key={filter.value}>
            <p className='landing-filter-overlay--section-title'>Por {filter.name.toLowerCase()}</p>
            {filter?.childs?.map((item) => (
              <div
                className='filter-course-characteristics--item-container'
                key={item.value}
                onClick={()=>handleClickItem(item.value)}
              >
                <CheckBoxComponent
                  className='landing-filter-overlay--checkbox'
                  checked={selectedItems.includes(item.value)}
                  onClick={()=>handleClickItem(item.value)}
                />
                <p className='landing-filter-overlay--item-title'>{item.name}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="landing-filter-overlay--actions-container">
        <ButtonComponent
          onClick={handleClickClear}
        >
          Limpiar filtros
        </ButtonComponent>
        <ButtonComponent onClick={handleClickFilter} variant='secondary'>
          Aplicar
        </ButtonComponent>
      </div>
    </div>
  )
}

export default LandingFilterOverlay
